<app-spinner></app-spinner>

<div class="mx-auto" style="width: 82%">

  <div class="d-flex flex-row">
    <p>
      Archivierte anzeigen
    </p>
    <input type="checkbox" name="" id="checkbox-showarchived" class="checkbox-slider"
           (click)="this.changeShowArchivedStatus($event)">
    <label for="checkbox-showarchived"></label>
  </div>

  <table class="table top">
    <thead>
    <tr>
      <th scope="col" class="pointer" (click)="this.sortTablebyColum('uuid')">
        UUID <i *ngIf="this.lastsort === 'uuid'"
                [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('salutation')">Anrede<i
        *ngIf="this.lastsort === 'salutation'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('title')">Titel<i
        *ngIf="this.lastsort === 'title'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('name')">
        Vorname <i *ngIf="this.lastsort === 'name'"
                   [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                   class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('lastname')">
        Nachname <i *ngIf="this.lastsort === 'lastname'"
                    [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                    class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('telephone')">
        Festnetz <i *ngIf="this.lastsort === 'telephone'"
                    [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                    class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('mobile')">
        Mobil <i *ngIf="this.lastsort === 'mobile'"
                 [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                 class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('mail')">
        Mail <i *ngIf="this.lastsort === 'mail'"
                [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('fax')">Fax<i
        *ngIf="this.lastsort === 'fax'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('note')">Bemerkung<i
        *ngIf="this.lastsort === 'note'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('archived')">Archiviert<i
        *ngIf="this.lastsort === 'archived'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>


      <th>Aktionen</th>
    </tr>
    </thead>
    <tbody id="table-values">
    <tr (click)="Helper.TableSelect($event)" *ngFor="let contact of this.contacts" id="{{contact.uuid}}">
      <td>{{ contact.uuid }}</td>
      <td>{{ contact.salutation }}</td>
      <td>{{ contact.title }}</td>
      <td>{{ contact.name }}</td>
      <td>{{ contact.lastname }}</td>
      <td>{{ contact.telephone }}</td>
      <td>{{ contact.mobile }}</td>
      <td>{{ contact.mail }}</td>
      <td>{{ contact.fax }}</td>
      <td>{{ contact.note }}</td>
      <td>
        <input type="checkbox" name="" id="checkbox{{contact.uuid}}"
               [disabled]="!PermissionsHelper.hasPermission('staff.customer.edit')"
               (click)="this.changeArchivedStatus($event,contact)" class="checkbox-slider"
               [checked]="contact.archived">
        <label for="checkbox{{contact.uuid}}"></label>
      </td>
      <td>
        <button class="btn btn-danger me-2" (click)="this.remoteEntryFromTable($event)"
                [disabled]="!PermissionsHelper.hasPermission('staff.contact.edit') || contact.archived">Ansprechpartner
          Löschen
        </button>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="mb-3 text-center">
    <button class="btn btn-success me-2" (click)="this.saveContacts()"
            [disabled]="!PermissionsHelper.hasPermission('staff.contact.edit')">Änderungen Speichern
    </button>
  </div>

  <div *ngIf="this.contacts?.length === 0" class="text-center m-3">
    <p>Aktuell gibt es leider keine Aktiven Kontakte</p>
  </div>
</div>
